/**
 * TypeSmsCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TypeSms} from '@/model/resource/TypeSms'

/* TODO: review generated class */
@HttpExclude()
export class TypeSmsCollection extends PageCollection<TypeSms> {
  constructor() {
    super(TypeSms)
  }

  queryAsPage() {
    return this.listTypeSms()
  }

  async listTypeSms() {
    return await Request.get(`/admin/type-sms`, {params: this.params})
      .name('listTypeSms')
      .as(this)
      .getResponse()
  }

  async listCsvTypeSms() {
    return await Request.get(`/admin/type-sms/csv`, {params: this.params})
      .name('listCsvTypeSms')
      .as(this)
      .getResponse()
  }
}
